import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { PrimeNG } from 'primeng/config';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [ RouterModule ]
})
export class AppComponent {

  constructor(private themeService: ThemeService, private translateService: TranslateService, private config: PrimeNG) {
    this.themeService.loadSaved();

    this.translateService.addLangs(['it', 'en']);
    this.translateService.setFallbackLang('en');

    const browserLang = this.translateService.getBrowserLang();
    let lang = browserLang === undefined ? 'en' :  (browserLang.match(/en|it/) ? browserLang : 'en');
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));
  }
}
